<template>
    <section class="font-poppins flex md:flex-col" @click="pages">
        <div>
            <AdminDashboardNav/>
        </div>
        <div class="w-screen p-2 md:pl-1 md:pr-1">
            <section class="mt-6">
                <div class=" flex justify-between md:flex-col-reverse">
                    <div class="md:mt-6">
                        <GetDate/>
                        <p class="text-blue-700 font-bold text-2xl md:text-lg">MANAGE DSOS</p>
                    </div>

                    <div class=" mr-10">
                        <Notification/>
                    </div>
                </div>
            </section>
            <section v-if="pendingDsos">

                <section class=" mt-10">
                    <div class="text-sm flex justify-end ">
                    
                        <div class="relative">
                            <input v-model="searchQuery" @click="search = !search" class="border outline-none w-72 p-2 rounded-lg bg-gray-100 text-xs" type="text" name="search" id="search" placeholder="Search name, email...">
                            <i class="fa fa-search -ml-8"></i>
                        </div>
                    </div>
                </section>
                <div>
                    <button class=" ml-4 text-blue-700 cursor-pointer md:mt-4" @click="goBack" ><i class="fa fa-arrow-left mr-2"></i>Go Back</button>
                    <router-link to="/approved-dsos" class="text-blue-600 border ml-4 p-2">Approved Dsos</router-link>
                </div>
                <div class="font-bold text-xl pb-4 flex mt-4">
                    <p>Pending Approvals</p>
                    <i v-if="isLoading" class="fa  fa-spinner fa-spin  ml-4 text-blue-600"></i>    
                </div>

                <div class="text-sm md:overflow-x-auto">
                    <table class="w-full mt-5 md:border-collapse md:w-full">
                        <tbody>
                            <tr class="text-left  border-b-2">
                                <th>Name</th>
                                <th>Email</th>
                                <th>Location</th>
                                <th>Company Name</th>
                                <th>Attachment(s)</th>
                                <th>Status</th>
                                <th>Reg Date</th>
                            </tr>
                            
                            <tr v-for="dso in filterName" :key="dso.dsoId" class="hover:bg-gray-300 hover:border hover:border-blue-700 p-2 border-b-2">
                                <td>{{dso.firstName}} {{dso.lastName}}</td>
                                <td class="text-blue-700 p-2">{{dso.email}}</td>
                                <td>{{dso.country}}, {{dso.state}}</td>
                                <td>{{dso.companyName}}</td>
                                <td class=" text-blue-500"> <span class="fa fa-link mr-1"></span>{{dso.filesCount}} files</td>
                                <td class="pending"><span class=" fa fa-circle mr-1 "></span> {{dso.status}}</td>
                                <td>{{moment(dso.dateRegistered).format('DD/MM/YYYY')}} </td>
                                    <td><span @click="toggleList(dso)" class=" fa fa-ellipsis-v ml-3 text-gray-500 cursor-pointer"></span>
                                <div class=" relative">
                                    <ul class="absolute right-5 text-xs bg-gray-50 pl-8 pt-4 pb-4 pr-8 w-44" v-show="dso.navList">
                                        <router-link :to="{name: 'pending-dso-info', params: {id: dso.email}}">
                                            <li class="border-b-2 cursor-pointer">View Information</li>
                                        </router-link>
                                        <router-link :to="{name: 'email-center', params: {id: dso.email}}">
                                        <li class="mt-2 border-b-2  cursor-pointer">Message</li>
                                        </router-link>
                                        <li class="mt-2 border-b-2  cursor-pointer" @click="approveDso(dso)">Approve Dso</li>
                                        <li v-if=" dso.status === 'approved' || dso.status === 'active' " class="mt-2 border-b-2  cursor-pointer" @click="blockDso(dso)">Block Dso</li>
                                        <li v-if="dso.status === 'blocked'" class="mt-2 border-b-2  cursor-pointer" @click="unblockDso(dso)">Unblock Dso</li>
                                        <li class="mt-2 border-b-2 cursor-pointer" @click="deleteDsoModal(dso)">Delete Dso</li>
                                    </ul>
                                </div></td>
                            </tr>

                            
                            
                        </tbody>
                    </table>
                </div>

                <div v-if="!searchQuery" class="flex justify-between mt-10 text-gray-500">
                    <div>
                        <p>Showing {{currentPage}} of {{totalPages}} Pages of {{totalDsos}} Dsos </p>
                    </div>

                    <div class="flex">
                        <button @click="prev" class="border w-24 text-center text-blue-600  border-blue-600"> <i class="fa fa-angle-left mr-2"></i>Previous </button>
                        <button @click="next" class="border w-24 text-center border-blue-600 text-blue-600 ml-1">Next <i class="fa fa-angle-right ml-2"></i></button>
                    </div>
                </div>
            </section>    
        </div>

        <div>
            <DeleteModal
            v-show="deleteModal"
            @close="closeModal"
            :message="message"
            @getDsos="getDsos"
            :dsoId="dsoId"
            />
        </div>
    </section>
</template>

<script>
import axios from 'axios';
import moment from 'moment';
import DeleteModal from './DeleteModal.vue';
import {baseUrl} from '../../../Config';
import GetDate from '../GetDate.vue';
import Notification from '../Notification.vue';
import AdminDashboardNav from '../AdminDashboardNav.vue';
const url = baseUrl;
export default {
    components: {
        DeleteModal,
        GetDate,
        Notification,
        AdminDashboardNav
    },

    data() {
        return {
            navList: null,
            searchQuery: '',
            filter: '',
            search: null,
            showFilter: true,
            pendingDsoInfo:false,
            pendingDsos: true,
            dsos: [],
            isLoading: false,
            page: 1,
            selectedName: null,
            status: "approved",
            deleteStatus: "deleted",
            blockStatus: "blocked",
            page1: "",
            totalDsos: "",
            token: localStorage.getItem("token"),
            deleteModal:false,
            message: "",
            dsoId :"",
             currentPage:1,
            pageSize:20,
            searchLength: "",
            totalPages: "",
        }
    },

    computed: {
            filterName() {
            const query = this.searchQuery.toLowerCase()
            if(this.searchQuery) {
               return this.dsos.filter((theOrder) => {  
                     return Object.values(theOrder).some((word) => String(word).toLowerCase().includes(query))
                })
            }  else {
                return this.dsos.filter((row, index) => {
                let start = (this.currentPage -1)*this.pageSize;
                let end = this.currentPage*this.pageSize;
                let totalPages = this.dsos.length / this.pageSize
                this.totalPages = Math.round(totalPages)
                if(this.totalPages == 0) {
                    this.totalPages = 1
                }
                if(index >= start && index < end) return true;
                })
            }
        }
    },

    mounted() {
        this.getDsos();
        this.networkError();
    },

    methods: {
        moment(date) {
            return moment(date);
        },

         closeModal() {
            this.deleteModal = false;
        },
        deleteDsoModal(dso) {
            this.dsoId = dso.dsoId;
            dso.navList = !dso.navList
            this.deleteModal = true;
            this.message =  "Are you sure you want to perform this action?"
        },

        goBack() {
            this.$router.go(-1)
        },

        next() {
            if((this.currentPage*this.pageSize) < this.dsos.length) this.currentPage++;
        },

        prev() {
            if(this.currentPage > 1) this.currentPage--
        },
        toggleList(dso) {
            dso.navList = !dso.navList
        },
        pages(dso) {
            dso.navList = !dso.navList
        },

        showDetails(eachDso) {
            this.selectedName = eachDso;
            this.showFilter = false
            this.getDsos()
        },

        getDsos() {
            this.isLoading = true
            axios({
                method: 'GET',
                url: `${url}/v1/web/dsos?status=pending`,
                headers: {
                    'Content-type': 'application/json',
                    authorization: `Bearer ${this.token}`,
                    'cg-key':  '7C99A10492E73F0A6B8F64029386A24DE7FAA2FC5EBFE8948242F423CADA3'
                },
            })
            .then((response) => {
                this.isLoading = false;
                this.dsos = response.data.data.results;
                this.page1 = this.dsos.length;
                this.totalDsos = response.data.data.meta.totalResults;
            })
            .catch((error) => {
                console.log(error)
            })
            
        },

        approveDso(dso) {
            dso.navList = !dso.navList
            axios({
                method: 'PUT',
                url: `${url}/v1/web/dsos/update/status/${dso.dsoId}`,
                headers: {
                    Authorization: 'Bearer' + localStorage.getItem("token"),
                    'Content-type': 'application/json',
                    'cg-key':  '7C99A10492E73F0A6B8F64029386A24DE7FAA2FC5EBFE8948242F423CADA3'
                },
                data : {
                    status : this.status
                }
            })
            .then((response) => {
                this.getDsos()
                console.log(response)
            }) 
            .catch((error) => {
                console.log(error)
            })
        },

        blockDso(dso) {
            dso.navList = !dso.navList
            axios({
                method: 'PUT',
                url: `${url}/v1/web/dsos/update/status/${dso.dsoId}`,
                headers: {
                    Authorization: 'Bearer' + localStorage.getItem('token'),
                    'Content-type': 'application/json',
                    'cg-key':  '7C99A10492E73F0A6B8F64029386A24DE7FAA2FC5EBFE8948242F423CADA3'
                },
                data : {
                    status : this.blockStatus
                }
            })
            .then((response) => {
                this.getDsos();
                response;
            }) 
            .catch((error) => {
                console.log(error)
            })
        },

        unblockDso(dso) {
            dso.navList = !dso.navList
            axios({
                method: 'PUT',
                url: `${url}/v1/web/dsos/update/status/${dso.dsoId}`,
                headers: {
                    Authorization: 'Bearer' + localStorage.getItem('token'),
                    'Content-type': 'application/json',
                    'cg-key':  '7C99A10492E73F0A6B8F64029386A24DE7FAA2FC5EBFE8948242F423CADA3'
                },
                data : {
                    status : this.status
                }
            })
            .then((response) => {
                this.getDsos();
                response;
            }) 
            .catch((error) => {
                console.log(error)
            })
        },

       
        networkError() {
            if(!navigator.onLine) {
                this.$router.push('/network-error')
            } 
        }
    }
}
</script>

<style scoped>
.pending {
    color: rgb(243, 243, 9);
}
</style>